import { Controller } from "@hotwired/stimulus"
import { VisitHelper } from "~/helpers/visit_helper"

export default class extends Controller {
  static get targets() {
    return ["frame"]
  }

  applyFilter({ detail: { name, value } }) {
    let params = {}

    params[name] = value

    // This method is called when a filter is applied. You can only have a filter on either user or role, we remove the other filter when adding either of these
    if (name === "user_id") {
      params["user_role"] = ""
    }

    if (name === "user_role") {
      params["user_id"] = ""
    }

    this.frameTarget.src = new URL(window.location)
    VisitHelper.update(this.frameTarget.id, params)
  }

  applyDateRange({ detail: { startDate, endDate, range } }) {
    let params = {
      range: range,
      start_date: startDate,
      end_date: endDate,
    }

    this.frameTarget.src = new URL(window.location)
    VisitHelper.update(this.frameTarget.id, params)
  }
}
